<template lang="pug">
    div
        v-select(
            class="style-chooser"
            :options="options"
            :multiple="multiple"
            placeholder="Edges"
            :reduce="option => option.value"
             @search="getOptionsDebounce"
            :value="$store.state.dashboard.queryFilter.edgeNames"
            @input="updateValue"
        )
            span(slot="no-options") {{ $t('main.selectNotFoundText') }}
</template>
<script>
import { getFormOptions } from "@/api/formoptions";
import { _debounce, isSameJson } from "@/libs/utils";
export default {
    name: "ServiceGroupNameSelector",
    components: {},
    props: {
        multiple: { type: Boolean, default: true },
    },
    watch: {
        groupNames: function (newVal, oldVal) {
            if (!isSameJson(newVal, oldVal)) {
                this.$store.commit("SET_DASHBOARD_QUERY_FILTER", { key: "edgeNames", value: [] });
                this.getOptions();
            }
        },
    },
    data() {
        return {
            options: [],
        };
    },
    computed: {
        groupNames() {
            let groupNames = this.$store.state.dashboard.queryFilter.groupNames;
            return groupNames.length > 0 ? groupNames : "*";
        },
        getOptionsQueryString() {
            let searchParams = {};
            searchParams.groupNames = this.groupNames;
            return new URLSearchParams(searchParams).toString();
        },
    },
    methods: {
        getOptions() {
            getFormOptions(`groupasset/edgenames?${this.getOptionsQueryString}`).then((res) => {
                this.options = res.data.options;
            });
        },
        updateValue(value) {
            this.$store.commit("SET_DASHBOARD_QUERY_FILTER", { key: "edgeNames", value: value });
            this.$emit("updateEdgeValue", value);
        },
    },
    mounted() {
        this.getOptions();
    },
    created() {
        var self = this;
        this.getOptionsDebounce = _debounce(function (queryValue, loading) {
            loading(true);
            queryValue = queryValue || "";
            getFormOptions(`groupasset/edgenames?nodeId=*${queryValue}*&${self.getOptionsQueryString}`).then((res) => {
                self.options = res.data.options;
                loading(false);
            });
        });
    },
    destroyed() {},
    beforeDestroy() {},
};
</script>



// WEBPACK FOOTER //
// src/components/FormItems/EdgeNameSelector.vue